import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import AddInputBtn from '../AddInputBtn';
import DeleteInputBtn from '../DeleteInputBtn';
import { MediumButton } from '../../styles/Buttons';
import { Form } from '../../styles/FormStyle';
import { useTranslation } from 'react-i18next';
import FormActionBtns from '../FormActionBtns';

const InputWrapper = styled.div`
    display: grid; 
    grid-template-columns: 2fr 3.2rem; 
    position: relative; 

    /* Input fields */ 
    & > div:first-of-type {
        display: flex;
        justify-content: center; 
        align-items: flex-end; 
        gap: 1rem;
        margin: 0 0 1rem 0;
            
        & > div > input {
            margin: 1rem 0 0 0; 
        } 
            
        & > div:first-of-type,
        & > div:nth-of-type(2){
            flex: 1; 
        }
    }

    /* Delete button */ 
    & > div:last-of-type {
        position: absolute; 
        right: 0; 
        top: 35px; 
    }

`;

const ExpandTextArea = styled.div`
    position: relative; 
    display: inline-block; 
    width: 100%; 
    
    & > div {
        position: absolute;
        bottom: 28px; 
        right: 10px; 
        width: 16px;
        height: 16px; 
        cursor: se-resize;
        background-size: cover;
        background-image: url('/expand-icon.svg');  
        pointer-events: none; 
        transform: rotate(90deg); 
    }
`;

const InfoForm = ({ item, setItem, handleOnChange, handleSubmit, title, dynamicFields, buttonColorTheme, isEditing, handleEditCancel }) => {
    const { t } = useTranslation(); 
    const [height, setHeight] = useState(100);
    const textareaRef = useRef(null);


    const handleMouseDown = (event) => {
        const startY = event.clientY;
        const startHeight = textareaRef.current.offsetHeight;

        const onMouseMove = (e) => {
            const newHeight = startHeight + (e.clientY - startY);
            // Set a minimum height if desired
            if (newHeight > 50) {
                setHeight(newHeight);
            }
        };

        const onMouseUp = () => {
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };

        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
    };

    return (
        <Form $theme={buttonColorTheme} onSubmit={handleSubmit}>
            <h5>{title}</h5>
            <div>
                {dynamicFields.map((field, index) => (
                    <div key={index}>
                        <label>
                            {field.label}
                            {!!field.required && (
                                <span> *</span>
                            )}
                        </label>
                        {field.type === 'textarea' ? (
                            <ExpandTextArea onMouseDown={handleMouseDown}>
                                <textarea
                                    key={index}
                                    name={field.name}
                                    placeholder={field.placeholder}
                                    value={item[field.name]}
                                    onChange={handleOnChange}
                                    required={field.required === true}
                                    ref={textareaRef}
                                    style={{ height: `${height}px`, resize: 'none', padding: '8px' }}
                                    spellCheck={false}
                                ></textarea>
                                <div></div>
                            </ExpandTextArea>
                        ) : (
                            <input
                                key={index}
                                type={field.type}
                                name={field.name}
                                placeholder={field.placeholder}
                                min={field.type === 'date' ? '0000-01-01' : ''}
                                max={field.type === 'date' ? '9999-12-31' : ''}
                                value={
                                    item[field.name] && item[field.name].includes('T') && field.type === 'date'
                                        ? item[field.name].split('T')?.[0]
                                        : item[field.name] || ''
                                }
                                onChange={handleOnChange}
                                required={field.required === true}
                            />
                        )}
                    </div>
                ))}
                {item.document_links && item.document_links.map((link, index) => (
                    <InputWrapper key={index}>
                        <div>
                            <div>
                                <label>{`${t('common.formLabels.fileName.name')} #${index + 1}`}</label>
                                <input
                                    type="text"
                                    name={`document_links.${index}.fileName`}
                                    placeholder={`${t('common.formLabels.fileName.label')}`}
                                    value={link.fileName}
                                    onChange={handleOnChange}
                                />
                            </div>
                            <div>
                                <label>{`${t('common.formLabels.url.name')} #${index + 1}`}</label>
                                <input
                                    type="text"
                                    name={`document_links.${index}.url`}
                                    placeholder={`${t('common.formLabels.url.label')}`}
                                    value={link.url}
                                    onChange={handleOnChange}
                                />
                            </div>
                        </div>
                        <div>
                            <DeleteInputBtn
                                item={item}
                                setItem={setItem}
                                index={index}
                                theme={buttonColorTheme}
                            />
                        </div>
                    </InputWrapper>
                ))}
                {(item.document_links.length === 1 || item.document_links.length === 0) && (
                    <AddInputBtn
                        item={item}
                        setItem={setItem}
                        label={`${t('common.addBtnLabel')} ${t('common.formLabels.fileName.btnLabel')}`}
                        theme={buttonColorTheme}
                    />
                )}
            </div>
            {!!isEditing ? (
                <FormActionBtns 
                    theme={buttonColorTheme}
                    handleEditCancel={handleEditCancel}
                />
            ) : (
                <MediumButton 
                    $theme={buttonColorTheme} 
                    type="submit"
                >
                    {t('common.saveBtnLabel')}
                </MediumButton>
            )}
        </Form>
    )
}

export default InfoForm